module.exports = __webpack_public_path__ + "img/menuTiao.ec8fe7f2.png";